import React from 'react';
import styled from 'styled-components';

const TeamanicsButtonStyle = styled.button`
font-size: .875rem !important;
line-height: 1.5 !important;
background: #1F9DFC;
color: white !important;
border : 1px solid transparent;
padding: 0.25rem 1.5rem !important;
border-radius: 1.2rem !important;
// margin-left: 0.5rem !important;

&:focus,
  &:active {
    outline: none;
    border: 1px solid  #1F9DFC !important;;
  }

  &:hover {
    font-size: .875rem !important;
    line-height: 1.5 !important;
    background-color: white !important;
    border:1px solid #1F9DFC !important ;
    color: #1F9DFC !important;
    padding: 0.25rem 1.5rem !important;
    border-radius: 1.2rem !important;
    // margin-left: 0.5rem !important;+
  }
`;

function TeamanicsButton({ children, ...rest }) {
  return <TeamanicsButtonStyle {...rest}>{children}</TeamanicsButtonStyle>;
}

export default TeamanicsButton;